import type { ReactNode } from "react";
import { cx } from "@/lib/cx";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Estado vazio com acao sugerida — nunca tela em branco (RNF-UX-008). */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cx("empty", className)} role="status">
      {icon ? <div className="big">{icon}</div> : null}
      <h2 className="text-base font-bold text-fg-primary">{title}</h2>
      {description ? <p className="max-w-[300px] text-[13px]">{description}</p> : null}
      {action}
    </div>
  );
}
